import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import CommonHeader from "../Sub/CommonHeader";
import Footer from "../Sub/Footer";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { singleOrder } from "../../reducers/orderDetailsReducer";

const Response = () => {
  const { orderid } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (orderid) {
      dispatch(singleOrder(orderid));
    }
  }, [orderid, dispatch]);

  const { singleOrderData } = useSelector((state) => state.orderDetailReducer);

  return (
    <>
      <CommonHeader />
      <div className="py-5 bg-light min-vh-100">
        <Container>
          {singleOrderData && (
            <div
              className="bg-white p-5 rounded-4 shadow  border-5  mx-auto"
            // style={{ maxWidth: "1000px" }}
            >
              {/* Header */}
              <div className="text-center mb-4">
                <h1 className="text-success fw-bold mb-2">
                  🎉 Plan Successfully Purchased!
                </h1>
                <p className="fs-5 text-muted mb-0">
                  Thank you for your purchase! Your plan has been activated and a confirmation email has been sent.
                </p>
              </div>

              <hr className="my-4" />

              {/* Customer and Order Details */}
              <div className="d-flex flex-column flex-md-row justify-content-between gap-4">
                <div className="w-100">
                  <h5 className="text-dark fw-bold mb-3">👤 Customer Information</h5>
                  <ul className="list-unstyled mb-4">
                    <li className="mb-2"><strong>Name:</strong> {singleOrderData.user?.firstName} {singleOrderData.user?.lastName}</li>
                    <li className="mb-2"><strong>Email:</strong> {singleOrderData.user?.email}</li>
                    <li className="mb-2"><strong>Mobile:</strong> {singleOrderData.user?.phone}</li>
                  </ul>
                </div>

                <div className="w-100">
                  <h5 className="text-dark fw-bold mb-3">🧾 Order Details</h5>
                  <ul className="list-unstyled mb-4">
                    <li className="mb-2"><strong>Order ID:</strong> {singleOrderData.orderid}</li>
                    <li className="mb-2">
                      <strong>Order Date:</strong>
                      {new Date(singleOrderData.createdAt).toLocaleDateString("en-GB")}
                    </li>

                    <li className="mb-2"><strong>Transaction ID:</strong> {singleOrderData.transactionDetail?.transactionId}</li>
                  </ul>
                </div>
              </div>

              <hr className="my-4" />

              {/* Plan Info */}
              <h5 className="text-dark fw-bold mb-3">📦 Plan Information</h5>


              <div className="d-flex flex-column flex-md-row justify-content-between gap-4">
                <div className="w-100">
                  <ul className="list-unstyled mb-4">
                    <li className="mb-2"><strong>Name:</strong> {singleOrderData.item?.name}</li>
                    <li className="mb-2"><strong>Description:</strong>
                      <p>{singleOrderData.item?.description}</p>
                    </li>

                  </ul>
                </div>

                <div className="w-100">
                  <ul className="list-unstyled mb-4">
                    <li className="mb-2"><strong>Service:</strong> {singleOrderData.item?.category?.name}</li>
                    <li className="mb-2"><strong>Buy Date:</strong> {new Date(singleOrderData.item?.createdAt).toLocaleString()}</li>
                    <li className="mb-2"><strong>Plans Validity:</strong> {singleOrderData.item?.timePeriod} days</li>
                  </ul>
                </div>
              </div>

              <hr className="my-4" />
              <div className="d-flex flex-column mt-3">

                <div className="d-flex justify-content-between mb-2">
                  <strong>MRP:</strong>
                  <span>₹{singleOrderData.item?.mrp}</span>
                </div>
                <hr className="my-2" />
                <div className="d-flex justify-content-between mb-2">
                  <strong>Sale Price:</strong>
                  <span>₹{singleOrderData.item?.sale}</span>
                </div>
                <hr className="my-2" />
                <div className="d-flex justify-content-between mb-2">
                  <strong>Tax %:</strong>
                  <span>{singleOrderData.item?.tax_class?.percentage}%</span>
                </div>
                <hr className="my-2" />
                <div className="d-flex justify-content-between mb-2">
                  <strong>Total Tax:</strong>
                  <span>₹{singleOrderData.totalTaxAmount}</span>
                </div>
                <hr className="my-2" />
                <div className="d-flex justify-content-between mb-2">
                  <strong>Discount:</strong>
                  <span>₹{singleOrderData.totaldiscount}</span>
                </div>
                <hr className="my-2" />
                <div className="d-flex justify-content-between mb-2">
                  <strong>Coupon Discount:</strong>
                  <span>₹{singleOrderData.couponDiscount || 0}</span>
                </div>
                <hr className="my-2" />
                {/* Total Payable */}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <p className="fw-bold fs-5 text-dark mb-0">
                    <strong>Total Payable:</strong>
                  </p>
                  <p className="fw-bold fs-5 text-success mb-0">
                    ₹{Number(singleOrderData.totalPaybleAmount).toFixed(2)}
                  </p>
                </div>
              </div>


            </div>
          )}
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default Response;




